import React, { useContext, useEffect, useState } from "react";
import styled from "styled-components";
import PostNordIcon from "./../../../assets/images/postnordIcon.png";
import * as Library from "../../../utils/Library";
import moment from "moment";
import DefaultErrorPopup from "./DefaultErrorPopup";
import confirmSpinner from "./../../../assets/images/buttonSpinner.png";
import { DefaultPopupCard } from "./DefaultPopupCard";
import LayoutContext from "../../../contexts/LayoutContext";
import UserContext from "../../../contexts/UserContext";
import StandardsContext from "../../../contexts/StandardsContext";
import FloatingInput from "../forms/FloatingInput";

/* #region SCOPED CSS */
const StyledPage = styled.div`
    & {
    }

    //GLOBAL
    .form-type-shipping .label {
        padding: 0;
    }

    .input-field,
    .input-field2,
    .input-field3,
    .input-field4 {
        min-width: 50px !important;
        overflow: hidden;
        height: 46px;
        padding: 0 16px !important;
    }

    .input-field > div,
    .input-field2 > div,
    .input-field3 > div,
    .input-field4 > div {
        height: unset;
    }

    .input-field input,
    .input-field2 input,
    .input-field3 input,
    .input-field4 input {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
        width: 100%;
    }
    //END GLOBAL

    .form-type-shipping,
    .form-type-shipping * {
        box-sizing: border-box;
    }
    .form-type-shipping {
        //background: var(--surface-surface-secondary, #121212);
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: center;
        justify-content: flex-start;
        flex-shrink: 0;
        position: relative;
        //box-shadow: var(--dropshadow-pop-up2-box-shadow, 4px 4px 87.4px 0px rgba(0, 0, 0, 1));
    }
    .frame-29643 {
        padding: 24px;
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-313546 {
        display: flex;
        flex-direction: column;
        gap: 24px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-313545 {
        display: flex;
        flex-direction: column;
        gap: 24px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-313474 {
        display: flex;
        flex-direction: row;
        gap: 16px;
        align-items: flex-start;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .address-for-shipment {
        color: var(--text-text-primary, #ffffff);
        text-align: left;
        font-family: "Open Sans", sans-serif;
        font-size: 22px;
        line-height: 28px;
        font-weight: 600;
        position: relative;
        flex: 1;
    }
    .frame-29057 {
        border-radius: 5px;
        padding: 4px 8px 4px 8px;
        display: flex;
        flex-direction: row;
        gap: 0px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        width: 30px;
        height: 30px;
        position: relative;
        overflow: visible;
        background: var(--Buttons-button-secondary, #212121);
    }
    .frame-313544 {
        display: flex;
        flex-direction: column;
        gap: 24px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-313543 {
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .info-action-card {
        border-radius: 5px;
        border-style: solid;
        border-color: var(--border-border-primary, rgba(166, 166, 166, 0.2));
        border-width: 1px;
        padding: 10px 16px 10px 16px;
        display: flex;
        flex-direction: row;
        gap: 16px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
        height: 65px;
        overflow: hidden;
    }
    .frame-29614 {
        display: flex;
        flex-direction: row;
        gap: 16px;
        align-items: center;
        justify-content: flex-start;
        flex-shrink: 0;
        width: 100%;
        position: relative;
    }
    .frame-313487 {
        border-radius: 60px;
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        width: 45px;
        height: 45px;
        position: relative;
        overflow: visible;
        background: var(--Buttons-button-tertiary, #232832);
    }
    .frame-313574 {
        display: flex;
        flex-direction: column;
        gap: 6px;
        align-items: flex-start;
        justify-content: center;
        flex: 1;
        position: relative;
    }
    .frame-313454 {
        display: flex;
        flex-direction: row;
        gap: 4px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-29717 {
        display: flex;
        flex-direction: row;
        gap: 4px;
        align-items: center;
        justify-content: flex-start;
        flex: 1;
        position: relative;
    }
    .frame-313359 {
        display: flex;
        flex-direction: row;
        gap: 3px;
        align-items: center;
        justify-content: flex-start;
        flex-shrink: 0;
        position: relative;
    }
    .product-name {
        color: var(--text-text-primary, #ffffff);
        text-align: left;
        font-family: "Open Sans", sans-serif;
        font-size: 12px;
        line-height: 14px;
        font-weight: 400;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }
    .frame-29607 {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        height: 14px;
    }
    .image-153 {
        flex-shrink: 0;
        width: 51.96px;
        height: 9px;
        position: relative;
        object-fit: cover;
    }
    .frame-313453 {
        display: flex;
        flex-direction: row;
        gap: 4px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-3133592 {
        display: flex;
        flex-direction: row;
        gap: 3px;
        align-items: center;
        justify-content: flex-start;
        flex: 1;
        position: relative;
        color: #8c8c8c;
        color: var(--Text-text-secondary, #8c8c8c);

        /* Caption-Semibold */
        font-family: "Open Sans";
        font-size: 12px;
        font-style: normal;
        font-weight: 400;
        line-height: 14px;
    }
    .frame-313590 {
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .recipient {
        color: var(--text-text-primary, #ffffff);
        text-align: left;
        font-family: var(--heading-4-font-family, "Open Sans", sans-serif);
        font-size: var(--heading-4-font-size, 14px);
        line-height: var(--heading-4-line-height, 20px);
        font-weight: var(--heading-4-font-weight, 600);
        position: relative;
        align-self: stretch;
    }
    .frame-313472 {
        //opacity: 0.2;
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-29734 {
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .frame-29733 {
        display: flex;
        flex-direction: row;
        gap: 12px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .input-field {
        background: var(--surface-surface-secondary, #121212);
        border-radius: 5px;
        border-style: solid;
        //border-color: var(--border-border-secondary, #8c8f93);
        //border-color: #a6a6a633;
        border-width: 1px;
        padding: 16px;
        display: flex;
        flex-direction: row;
        gap: 0px;
        align-items: center;
        justify-content: flex-start;
        flex: 1;
        position: relative;
        box-shadow: var(--dropdown-input-field-box-shadow, 0px 0px 15px 0px rgba(0, 0, 0, 0.25));
    }
    .frame-313475 {
        display: flex;
        flex-direction: column;
        //gap: 4px;
        align-items: flex-start;
        justify-content: center;
        flex: 1;
        height: 14px;
        position: relative;
    }
    .label {
        color: var(--text-text-secondary, #8c8c8c);
        text-align: left;
        font-family: var(--label-xsmall-font-family, "Open Sans", sans-serif);
        font-size: var(--label-xsmall-font-size, 8px);
        line-height: var(--label-xsmall-line-height, 8px);
        font-weight: var(--label-xsmall-font-weight, 600);
        position: relative;
        align-self: stretch;
        display: flex;
        align-items: center;
        justify-content: flex-start;
    }
    .label2 {
        color: var(--text-text-primary, #ffffff);
        text-align: left;
        font-family: var(--label-medium-font-family, "Open Sans", sans-serif);
        font-size: var(--label-medium-font-size, 14px);
        line-height: var(--label-medium-line-height, 14px);
        font-weight: var(--label-medium-font-weight, 400);
        position: relative;
        align-self: stretch;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        background: transparent;
        outline: none;
        border: none;
    }
    .input-field2 {
        background: var(--surface-surface-secondary, #121212);
        border-radius: 5px;
        border-style: solid;
        //border-color: var(--border-border-secondary, #8c8f93);
        border-width: 1px;
        padding: 16px;
        display: flex;
        flex-direction: row;
        gap: 0px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        height: 46px;
        position: relative;
        box-shadow: var(--dropdown-input-field-box-shadow, 0px 0px 15px 0px rgba(0, 0, 0, 0.25));
    }
    .frame-3135452 {
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .address {
        color: #ffffff;
        text-align: left;
        font-family: var(--heading-4-font-family, "Open Sans", sans-serif);
        font-size: var(--heading-4-font-size, 14px);
        line-height: var(--heading-4-line-height, 20px);
        font-weight: var(--heading-4-font-weight, 600);
        position: relative;
        align-self: stretch;
    }
    .frame-29737 {
        //opacity: 0.2;
        display: flex;
        flex-direction: column;
        gap: 16px;
        align-items: flex-start;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        position: relative;
    }
    .chevron-down {
        flex-shrink: 0;
        width: 16px;
        height: 16px;
        position: relative;
        overflow: visible;
    }
    .input-field3 {
        background: var(--surface-surface-secondary, #121212);
        border-radius: 5px;
        border-style: solid;
        //border-color: var(--border-border-secondary, #8c8f93);
        border-width: 1px;
        padding: 16px;
        display: flex;
        flex-direction: row;
        gap: 0px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex: 1;
        position: relative;
        box-shadow: var(--dropdown-input-field-box-shadow, 0px 0px 15px 0px rgba(0, 0, 0, 0.25));
    }
    .input-field4 {
        background: var(--surface-surface-secondary, #121212);
        border-radius: 5px;
        border-style: solid;
        //border-color: var(--border-border-primary, rgba(166, 166, 166, 0.2));
        border-width: 1px;
        padding: 16px;
        display: flex;
        flex-direction: row;
        gap: 0px;
        align-items: center;
        justify-content: flex-start;
        flex: 1;
        position: relative;
        box-shadow: var(--dropdown-input-field-box-shadow, 0px 0px 15px 0px rgba(0, 0, 0, 0.25));
    }
    .label3 {
        color: var(--text-text-secondary, #8c8c8c);
        text-align: left;
        font-family: var(--label-medium-font-family, "Open Sans", sans-serif);
        font-size: var(--label-medium-font-size, 14px);
        line-height: var(--label-medium-line-height, 14px);
        font-weight: var(--label-medium-font-weight, 400);
        position: relative;
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        background: transparent;
        outline: none;
        border: none;
        height: 14px;
    }
    .checkbox {
        //opacity: 0.2;
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: flex-start;
        align-self: stretch;
        flex-shrink: 0;
        height: 24px;
        position: relative;
    }
    .vector {
        flex-shrink: 0;
        position: relative;
        overflow: visible;
    }
    .text-label {
        color: var(--text-text-primary, #ffffff);
        text-align: left;
        font-family: var(--subtitle-2-font-family, "Open Sans", sans-serif);
        font-size: var(--subtitle-2-font-size, 14px);
        line-height: var(--subtitle-2-line-height, 24px);
        font-weight: var(--subtitle-2-font-weight, 400);
        position: relative;
    }
    .btn-md-solid {
        background: var(--buttons-button-primary, #f7665f);
        border-radius: 5px;
        display: flex;
        flex-direction: row;
        gap: 10px;
        align-items: center;
        justify-content: center;
        align-self: stretch;
        flex-shrink: 0;
        height: 44px;
        position: relative;
        box-shadow: var(--bt-drop-shadow-box-shadow, 0px 0px 4px 0px rgba(30, 38, 49, 0.35));
    }
    .frame-313498 {
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        position: relative;
    }
    .spiner-with-bg {
        flex-shrink: 0;
        width: 20px;
        height: 20px;
        position: relative;
    }
    .spiner {
        width: 100%;
        height: 100%;
        position: absolute;
        right: 0%;
        left: 0%;
        bottom: 0%;
        top: 0%;
    }
    .ellipse-1 {
        background: var(--border-border-white, #ffffff);
        border-radius: 50%;
        opacity: 0.30000001192092896;
        width: 100%;
        height: 100%;
        position: absolute;
        right: 0%;
        left: 0%;
        bottom: 0%;
        top: 0%;
    }
    .ellipse-12 {
        background: var(--border-border-white, #ffffff);
        border-radius: 50%;
        width: 100%;
        height: 100%;
        position: absolute;
        right: 0%;
        left: 0%;
        bottom: 0%;
        top: 0%;
    }
    .frame-313497 {
        display: flex;
        flex-direction: row;
        gap: 8px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        position: relative;
    }
    .frame-313349 {
        display: flex;
        flex-direction: row;
        gap: 4px;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
        position: relative;
    }
    .button {
        color: var(--text-text-primary, #ffffff);
        text-align: center;
        font-family: var(--button-text-medium-regular-font-family, "Open Sans", sans-serif);
        font-size: var(--button-text-medium-regular-font-size, 14px);
        line-height: var(--button-text-medium-regular-line-height, 24px);
        font-weight: var(--button-text-medium-regular-font-weight, 400);
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .spinner-img {
        animation: spin 1s linear infinite;
    }

    @keyframes spin {
        to {
            transform: rotate(360deg);
        }
    }
`;
/* #endregion */

export default function ShipmentAdressPopup() {
    /* #region VARS */
    const [firstName, setFirstName] = useState(null);
    const [lastName, setLastName] = useState(null);
    const [company, setCompany] = useState(null);
    const [country, setCountry] = useState(null);
    const [address, setAddress] = useState(null);
    const [postalCode, setPostalCode] = useState(null);
    const [city, setCity] = useState(null);
    const [doorbell, setDoorbell] = useState(null);
    const [floor, setFloor] = useState(null);
    const [useAddressForFutureShipments, setUseAddressForFutureShipments] = useState(false);

    const [isFormValid, setIsFormValid] = useState(false);
    //const [countriesList, setCountriesList] = useState(["Norway"]); //TODO: GET COUNTRIES LIST
    const [isSaving, setIsSaving] = useState(false); //TODO: USE THIS TO SHOW SPINNER

    //STORE DATA
    const [storeAddress, setStoreAddress] = useState(null);
    const [storeAddressNumber, setStoreAddressNumber] = useState(null);
    const [storeAddressPostCode, setStoreAddressPostCode] = useState(null);
    const [storeCountry, setStoreCountry] = useState(null);
    const [shippingID, setShippingID] = useState(null);

    const [isFirstNameTyping, setIsFirstNameTyping] = useState(false);
    const [isLastNameTyping, setIsLastNameTyping] = useState(false);
    const [isCompanyTyping, setIsCompanyTyping] = useState(false);
    const [isAddressTyping, setIsAddressTyping] = useState(false);
    const [isDoorTyping, setIsDoorTyping] = useState(false);
    const [isFloorTyping, setIsFloorTyping] = useState(false);
    const [isPostalTyping, setIsPostalTyping] = useState(false);
    const [isCityTyping, setIsCityTyping] = useState(false);
    const [isCountryTyping, setIsCountryTyping] = useState(false);

    const [isErrorPopupOpen, setIsErrorPopupOpen] = useState(false);
    const [errorPopupData, setErrorPopupData] = useState({
        title: "",
        message: "",
        cancelBtnText: "",
        confirmBtnText: "",
        confirmActionText: "",
        cancelBtnAction: undefined,
        confirmBtnAction: undefined,
        isMobile: false
    });

    const {
        setShowShippingAddressPopup,
        shippingAddressPopupData,
        setShippingAddressPopupData,
        quickBuyPopup,
        showInfoPopup,
        setShowInfoPopup
    } = useContext(LayoutContext);
    const { checkoutCartData, setCheckoutCartData, shippingRecipient, setShippingRecipient, setQuickBuyData, quickBuyData } =
        useContext(UserContext);
    const { setDefaultNotificationCard } = useContext(StandardsContext);
    /* #endregion */

    /* #region EFFECTS */
    useEffect(() => {
        setIsFormValid(shippingRecipient?.firstName && shippingRecipient?.lastName && country && address && postalCode && city && doorbell);
    }, [shippingRecipient, country, address, postalCode, city, doorbell]);

    useEffect(() => {
        const itemID = shippingAddressPopupData;
        if (!itemID) return;

        const item = quickBuyPopup
            ? quickBuyData?.items?.find(item => item?.itemID === itemID)
            : checkoutCartData?.items?.find(item => item?.itemID === itemID);

        const userAddress = item?.UserAddress;
        const userData = item?.UserData;
        const storeData = item?.BOTagAlgorithmData?.storeDetail;
        if (!item) return;

        //if (userData?.firstName) setFirstName(userData?.firstName);
        // if (userData?.firstName && userData?.lastName)
        //     setShippingRecipient({ firstName: userData?.firstName, lastName: userData?.lastName });
        //if (userData?.lastName) setLastName(userData?.lastName);
        if (userData?.company) setCompany(userData?.company ?? "");
        if (userAddress?.country) setCountry(userAddress?.country);
        if (userAddress?.street) setAddress(userAddress?.street);
        if (userAddress?.postCode) setPostalCode(userAddress?.postCode);
        if (userAddress?.city) setCity(userAddress?.city);
        if (userAddress?.streetNumber) setDoorbell(userAddress?.streetNumber);
        if (userAddress?.floor) setFloor(userAddress?.floor);
        if (storeData?.country) setStoreCountry(storeData?.country);
        if (storeData?.address) setStoreAddress(storeData?.address);
        if (storeData?.addressNumber) setStoreAddressNumber(storeData?.addressNumber);
        if (storeData?.postalCode) setStoreAddressPostCode(storeData?.postalCode);
        if (item?.BOTagAlgorithmData?.cf?._id) setShippingID(item?.BOTagAlgorithmData?.cf?._id);
        setShippingRecipient({
            firstName: item?.BOTagData?.recipientJson?.firstName ? item?.BOTagData?.recipientJson?.firstName : userData?.firstName,
            lastName: item?.BOTagData?.recipientJson?.lastName ? item?.BOTagData?.recipientJson?.lastName : userData?.lastName,
            company: item?.BOTagData?.company ? item?.BOTagData?.company : ""
        });
    }, [shippingAddressPopupData]);
    /* #endregion */

    /* #region METHODS */

    const showErrorMessagePopup = (
        title,
        message,
        cancelBtnText,
        confirmBtnText,
        cancelBtnAction = undefined,
        confirmBtnAction = undefined
    ) => {
        setErrorPopupData({
            title: title,
            message: message,
            cancelBtnText: cancelBtnText,
            confirmBtnText: confirmBtnText,
            cancelBtnAction: cancelBtnAction,
            confirmBtnAction: confirmBtnAction
        });
        setIsErrorPopupOpen(true);
    };

    const handleSave = async () => {
        try {
            if (!isFormValid) {
                return;
            }

            //USING STATES FOR EXTRA FIELDS
            const formData = {
                SHIPPING_ID: shippingID,
                extraFields: {
                    isPostCode: postalCode,
                    isServiceCodes: "18",
                    isUserAddress: address,
                    isUserAddressNumber: doorbell,
                    isUserAddressPostCode: postalCode,
                    isStoreAddress: storeAddress,
                    isStoreAddressNumber: storeAddressNumber,
                    isStoreAddressPostCode: storeAddressPostCode,
                    isStartTime: moment().format("YYYY-MM-DDTHH:mm:ss"),
                    isUserCountry: country,
                    isStoreCountry: storeCountry
                }
            };
            const res = await Library.makeCommonPostRequest("Shippings", "apiOrderPromise", formData, false, setIsSaving);

            if (res?.data?.status !== 200) {
                const title = "Technical error";
                const message = "We were not able to contact the shipping partner. Please try again or go back to where you were.";
                const cancelBtnText = "Go back";
                const confirmBtnText = "Try again";
                const cancelBtnAction = () => {
                    setShowShippingAddressPopup(false);
                    if (showInfoPopup?.lastOpenState) {
                        setShowInfoPopup(prev => ({ ...prev, state: true, lastOpenState: false }));
                    }
                };

                showErrorMessagePopup(title, message, cancelBtnText, confirmBtnText, cancelBtnAction);
                return;
            } else if (!res?.data?.data?.validForPackageTypeCode || !res?.data?.data?.timeOfArrival === null) {
                const title = "Sorry! Can not ship to address";
                const message = "We are not able to provide shipping service to the address you shared. Please edit or change the address.";
                const cancelBtnText = "Go back to checkout";
                const confirmBtnText = "Edit / change address";
                const cancelBtnAction = () => {
                    setShowShippingAddressPopup(false);
                    if (showInfoPopup?.lastOpenState) {
                        setShowInfoPopup(prev => ({ ...prev, state: true, lastOpenState: false }));
                    }
                };

                showErrorMessagePopup(title, message, cancelBtnText, confirmBtnText, cancelBtnAction);
                return;
            }

            //Library.showSuccessMessage("Address saved successfully");
            Library.showNotification({
                message: "Address saved successfully",
                setDefaultNotificationCard
            });

            saveData();

            setShippingAddressPopupData(null);
            setShowShippingAddressPopup(false);
            if (showInfoPopup?.lastOpenState) {
                setShowInfoPopup(prev => ({ ...prev, state: true, lastOpenState: false }));
            }
        } catch (error) {}
    };

    const renderAddressText = () => {
        let addressText = "";
        if (address) {
            addressText += address;
        }
        if (doorbell) {
            addressText += " " + doorbell;
        }
        if (floor) {
            addressText += ", " + floor;
        }
        if (city || postalCode) {
            addressText += ", ";
            addressText += postalCode ? postalCode : "";
            addressText += city ? " " + city : "";
        }
        if (country) {
            addressText += ", " + country;
        }
        return addressText;
    };

    const saveData = () => {
        try {
            const itemID = shippingAddressPopupData;
            if (!itemID) return;

            const itemIndex = quickBuyPopup
                ? quickBuyData?.items?.find(item => item?.itemID === itemID)
                : checkoutCartData?.items?.find(item => item?.itemID === itemID);
            if (itemIndex === -1) throw new Error("Item not found in cart");
            const item = itemIndex; //quickBuyPopup ? quickBuyData?.items[itemIndex] : checkoutCartData?.items[itemIndex];
            const userAddress = item?.UserAddress;
            const userData = item?.UserData;
            // if (userData?.firstName) userData.firstName = shippingRecipient?.firstName;
            // if (userData?.lastName) userData.lastName = shippingRecipient?.lastName;
            if (userData?.company) userData.company = shippingRecipient?.company;
            if (userAddress?.country) userAddress.country = country;
            if (userAddress?.street) userAddress.street = address;
            if (userAddress?.postCode) userAddress.postCode = postalCode;
            if (userAddress?.city) userAddress.city = city;
            if (userAddress?.streetNumber) userAddress.streetNumber = doorbell;
            if (userAddress?.floor) userAddress.floor = floor;

            item.UserData = userData;
            item.UserAddress = userAddress;
            item.BOTagData.recipient = shippingRecipient?.firstName + " " + shippingRecipient?.lastName;
            item.BOTagData.recipientJson = {};
            item.BOTagData.recipientJson.firstName = shippingRecipient?.firstName;
            item.BOTagData.recipientJson.lastName = shippingRecipient?.lastName;
            item.BOTagData.company = shippingRecipient?.company;
            if (quickBuyPopup) {
                const allItems = [...quickBuyData?.items];
                allItems[itemIndex] = item;

                setQuickBuyData({ ...quickBuyData, items: allItems });
            } else {
                const allItems = [...checkoutCartData?.items];
                allItems[itemIndex] = item;

                setCheckoutCartData({ ...checkoutCartData, items: allItems });
            }
        } catch (error) {
            //Library.showErrorMessage(error.message);
            Library.showNotification({
                message: error.message,
                type: "error",
                setDefaultNotificationCard
            });
        }
    };
    const handleCloseBtn = () => {
        setShowShippingAddressPopup(false);
        if (showInfoPopup?.lastOpenState) {
            setShowInfoPopup(prev => ({ ...prev, state: true, lastOpenState: false }));
        }
    };
    /* #endregion */

    return (
        <>
            {isErrorPopupOpen ? (
                <DefaultErrorPopup
                    setIsPopupOpen={setIsErrorPopupOpen}
                    title={errorPopupData.title}
                    message={errorPopupData.message}
                    cancelBtnText={errorPopupData.cancelBtnText}
                    confirmBtnText={errorPopupData.confirmBtnText}
                    confirmActionText={errorPopupData.confirmActionText}
                    cancelBtnAction={errorPopupData.cancelBtnAction}
                    isMobile={errorPopupData.isMobile}
                />
            ) : (
                <DefaultPopupCard>
                    <StyledPage>
                        <div className="form-type-shipping">
                            <div className="frame-313546">
                                <div className="frame-313545">
                                    <div className="frame-313474">
                                        <div className="address-for-shipment">Address for shipment</div>
                                        <div className="frame-29057" onClick={handleCloseBtn} style={{ cursor: "pointer" }}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width="10" height="11" viewBox="0 0 10 11" fill="none">
                                                <path
                                                    d="M5.00282 5.13041L9.08994 1.04172C9.29988 0.832448 9.63936 0.832448 9.8292 1.04172C10.057 1.25099 10.057 1.59046 9.8292 1.79973L5.75994 5.88753L9.8292 9.97465C10.057 10.1846 10.057 10.5241 9.8292 10.7139C9.63936 10.9417 9.29988 10.9417 9.08994 10.7139L5.00282 6.64465L0.915025 10.7139C0.705755 10.9417 0.366278 10.9417 0.156986 10.7139C-0.0523286 10.5241 -0.0523286 10.1846 0.156986 9.97465L4.2457 5.88753L0.156986 1.79973C-0.0523286 1.59046 -0.0523286 1.25099 0.156986 1.04172C0.366278 0.832448 0.705755 0.832448 0.915025 1.04172L5.00282 5.13041Z"
                                                    fill="white"
                                                />
                                            </svg>
                                        </div>
                                    </div>
                                    <div className="frame-313544">
                                        <div className="frame-313543">
                                            <div className="info-action-card">
                                                <div className="frame-29614">
                                                    <div className="frame-313487">
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            width="21"
                                                            height="17"
                                                            viewBox="0 0 21 17"
                                                            fill="none">
                                                            <path
                                                                d="M4.5 1.38477H11.5C12.0531 1.38477 12.5 1.83164 12.5 2.38477V12.3848H8.32812C7.91563 11.2191 6.80625 10.3848 5.5 10.3848C4.73125 10.3848 4.03125 10.6723 3.5 11.1473V9.38477H2.5V12.3848V13.3848C2.5 15.041 3.84375 16.3848 5.5 16.3848C7.15625 16.3848 8.5 15.041 8.5 13.3848H12.5C12.5 15.041 13.8438 16.3848 15.5 16.3848C17.1562 16.3848 18.5 15.041 18.5 13.3848H20C20.275 13.3848 20.5 13.1598 20.5 12.8848C20.5 12.6098 20.275 12.3848 20 12.3848H19.5V7.75352C19.5 7.39414 19.3719 7.05039 19.1375 6.77852L16.6781 3.90977C16.3938 3.57539 15.9781 3.38477 15.5406 3.38477H13.5V2.38477C13.5 1.28164 12.6031 0.384766 11.5 0.384766H4.5C3.39687 0.384766 2.5 1.28164 2.5 2.38477V3.38477H1C0.725 3.38477 0.5 3.60977 0.5 3.88477C0.5 4.15977 0.725 4.38477 1 4.38477H8C8.275 4.38477 8.5 4.15977 8.5 3.88477C8.5 3.60977 8.275 3.38477 8 3.38477H3.5V2.38477C3.5 1.83164 3.94688 1.38477 4.5 1.38477ZM18.3406 7.38477H13.5V4.38477H15.5406C15.6875 4.38477 15.825 4.44727 15.9188 4.55977L18.3406 7.38477ZM13.5 8.38477H18.5V12.3848H18.3281C17.9156 11.2191 16.8062 10.3848 15.5 10.3848C14.7312 10.3848 14.0312 10.6723 13.5 11.1473V8.38477ZM3.5 13.3848C3.5 12.8543 3.71071 12.3456 4.08579 11.9706C4.46086 11.5955 4.96957 11.3848 5.5 11.3848C6.03043 11.3848 6.53914 11.5955 6.91421 11.9706C7.28929 12.3456 7.5 12.8543 7.5 13.3848C7.5 13.9152 7.28929 14.4239 6.91421 14.799C6.53914 15.1741 6.03043 15.3848 5.5 15.3848C4.96957 15.3848 4.46086 15.1741 4.08579 14.799C3.71071 14.4239 3.5 13.9152 3.5 13.3848ZM15.5 11.3848C16.0304 11.3848 16.5391 11.5955 16.9142 11.9706C17.2893 12.3456 17.5 12.8543 17.5 13.3848C17.5 13.9152 17.2893 14.4239 16.9142 14.799C16.5391 15.1741 16.0304 15.3848 15.5 15.3848C14.9696 15.3848 14.4609 15.1741 14.0858 14.799C13.7107 14.4239 13.5 13.9152 13.5 13.3848C13.5 12.8543 13.7107 12.3456 14.0858 11.9706C14.4609 11.5955 14.9696 11.3848 15.5 11.3848ZM2 5.38477C1.725 5.38477 1.5 5.60977 1.5 5.88477C1.5 6.15977 1.725 6.38477 2 6.38477H9C9.275 6.38477 9.5 6.15977 9.5 5.88477C9.5 5.60977 9.275 5.38477 9 5.38477H2ZM1 7.38477C0.725 7.38477 0.5 7.60977 0.5 7.88477C0.5 8.15977 0.725 8.38477 1 8.38477H8C8.275 8.38477 8.5 8.15977 8.5 7.88477C8.5 7.60977 8.275 7.38477 8 7.38477H1Z"
                                                                fill="white"
                                                            />
                                                        </svg>
                                                    </div>
                                                    <div className="frame-313574">
                                                        <div className="frame-313454">
                                                            <div className="frame-29717">
                                                                <div className="frame-313359">
                                                                    <div className="product-name">By:</div>
                                                                    <div className="frame-29607">
                                                                        <img className="image-153" src={PostNordIcon} alt="" />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="frame-313453">
                                                            <div className="frame-29717">
                                                                <div className="frame-3133592">
                                                                    <div
                                                                        style={{
                                                                            color: "#FFF",
                                                                            fontFamily: "Open Sans",
                                                                            fontSize: "12px",
                                                                            fontStyle: "normal",
                                                                            fontWeight: "400",
                                                                            lineHeight: "14px"
                                                                        }}>
                                                                        To:
                                                                    </div>
                                                                    {renderAddressText()}
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="frame-313590">
                                                <div className="recipient">Recipient</div>
                                                <div className="frame-313472">
                                                    <div className="frame-29734">
                                                        <div className="frame-29733">
                                                            <FloatingInput
                                                                label={"First name"}
                                                                value={shippingRecipient.firstName}
                                                                onChange={e => {
                                                                    setIsFirstNameTyping(true);
                                                                    setShippingRecipient({
                                                                        ...shippingRecipient,
                                                                        firstName: e.target.value
                                                                    });
                                                                }}
                                                                isTyping={isFirstNameTyping}
                                                            />
                                                            <FloatingInput
                                                                label={"Last name"}
                                                                value={shippingRecipient.lastName}
                                                                onChange={e => {
                                                                    setIsLastNameTyping(true);
                                                                    setShippingRecipient({
                                                                        ...shippingRecipient,
                                                                        lastName: e.target.value
                                                                    });
                                                                }}
                                                                isTyping={isLastNameTyping}
                                                            />
                                                        </div>
                                                        <FloatingInput
                                                            label={"Company / organization (optional)"}
                                                            value={shippingRecipient.company}
                                                            onChange={e => {
                                                                setIsCompanyTyping(true);
                                                                setShippingRecipient({
                                                                    ...shippingRecipient,
                                                                    company: e.target.value
                                                                }); //setCompany(e.target.value)
                                                            }}
                                                            isTyping={isCompanyTyping}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="frame-3135452">
                                            <div className="address">Address</div>
                                            <div className="frame-29737">
                                                <FloatingInput
                                                    label={"Country"}
                                                    value={country}
                                                    onChange={e => {
                                                        setIsCountryTyping(true);
                                                        setCountry(e.target.value);
                                                    }}
                                                    isTyping={isCountryTyping}
                                                />
                                                <div className="frame-29734">
                                                    <FloatingInput
                                                        label={"Address"}
                                                        value={address}
                                                        onChange={e => {
                                                            setAddress(e.target.value);
                                                            setIsAddressTyping(true);
                                                        }}
                                                        isTyping={isAddressTyping}
                                                    />

                                                    <div className="frame-29733" style={{ width: "100%" }}>
                                                        <FloatingInput
                                                            label={"Door / Street number"}
                                                            value={doorbell}
                                                            onChange={e => {
                                                                setIsDoorTyping(true);
                                                                setDoorbell(e.target.value);
                                                            }}
                                                            isTyping={isDoorTyping}
                                                        />
                                                        <FloatingInput
                                                            label={"Apt., floor (optional)"}
                                                            value={floor}
                                                            onChange={e => {
                                                                setIsFloorTyping(true);
                                                                setFloor(e.target.value);
                                                            }}
                                                            isTyping={isFloorTyping}
                                                        />
                                                    </div>
                                                    <div className="frame-29733">
                                                        <FloatingInput
                                                            label={"Postal code"}
                                                            value={postalCode}
                                                            onChange={e => {
                                                                setIsPostalTyping(true);
                                                                setPostalCode(e.target.value);
                                                            }}
                                                            isTyping={isPostalTyping}
                                                        />
                                                        <FloatingInput
                                                            label={"City"}
                                                            value={city}
                                                            onChange={e => {
                                                                setIsCityTyping(true);
                                                                setCity(e.target.value);
                                                            }}
                                                            isTyping={isCityTyping}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                            <div
                                                className="checkbox hide"
                                                onClick={() => setUseAddressForFutureShipments(!useAddressForFutureShipments)}
                                                style={{ cursor: "pointer" }}>
                                                <div className="vector">
                                                    {useAddressForFutureShipments ? (
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            width="18"
                                                            height="19"
                                                            viewBox="0 0 18 19"
                                                            fill="none">
                                                            <path
                                                                d="M9.5 4.88477L5 7.38477L3 10.3848C3.83333 11.8848 5.7 15.0848 6.5 15.8848C7.5 16.8848 10.5 15.3848 11.5 14.8848C12.3 14.4848 14.5 11.7181 15.5 10.3848L14 4.88477H9.5Z"
                                                                fill="white"
                                                            />
                                                            <path
                                                                fillRule="evenodd"
                                                                clipRule="evenodd"
                                                                d="M9 0.884766C4.02944 0.884766 0 4.9142 0 9.88477C0 14.8553 4.02944 18.8848 9 18.8848C13.9706 18.8848 18 14.8553 18 9.88477C18 4.9142 13.9706 0.884766 9 0.884766ZM13.2604 8.00876C13.5799 7.68924 13.5799 7.1712 13.2604 6.85168C12.9408 6.53216 12.4228 6.53216 12.1033 6.85168L7.77273 11.1822L5.89672 9.30622C5.5772 8.9867 5.05916 8.9867 4.73964 9.30622C4.42012 9.62574 4.42012 10.1438 4.73964 10.4633L7.19419 12.9179C7.5137 13.2374 8.03175 13.2374 8.35127 12.9179L13.2604 8.00876Z"
                                                                fill="#F7665F"
                                                            />
                                                        </svg>
                                                    ) : (
                                                        <svg
                                                            xmlns="http://www.w3.org/2000/svg"
                                                            width="18"
                                                            height="19"
                                                            viewBox="0 0 18 19"
                                                            fill="none">
                                                            <circle cx="9" cy="9.88477" r="8.5" stroke="#A6A6A6" strokeOpacity="0.2" />
                                                        </svg>
                                                    )}
                                                </div>
                                                <div className="text-labele">Use this address for future shipment orders</div>
                                            </div>
                                        </div>
                                        {/* TODO: CHECK OPACITY IS CORRECT */}
                                        <div
                                            className="btn-md-solid"
                                            style={{
                                                opacity: isFormValid ? 1 : 0.2,
                                                cursor: isFormValid ? "pointer" : "not-allowed"
                                            }}
                                            disabled={!isFormValid || isSaving}
                                            onClick={handleSave}>
                                            <div className="frame-313498">
                                                <div className="frame-313497">
                                                    <div className="frame-313349">
                                                        {isSaving ? (
                                                            <>
                                                                <img
                                                                    src={confirmSpinner}
                                                                    alt="confirmSpinner"
                                                                    style={{ width: "20px", height: "20px" }}
                                                                    className="spinner-img"
                                                                />
                                                                <div className="button">Updating...</div>
                                                            </>
                                                        ) : (
                                                            <div className="button">Done!</div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </StyledPage>
                </DefaultPopupCard>
            )}
        </>
    );
}
